import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IPageTranslation, IPageResource } from "../types";

export interface IPageTranslationQueryParameters {
    page?: RelationalValue<IPageResource>;
    locale: string;
}

export type IPageTranslationQueryResult = IPageTranslation;

export const pageTranslationQuery: IApiQueryFunction<IPageTranslationQueryParameters> = ({ page, locale }) => {
    if (!page) {
        return;
    }

    return {
        method: "GET",
        url: `/pages/${mapRelationalValue(page)}/translations/${locale}`,
    };
};

export const usePageTranslationQuery = createApiQueryHook<IPageTranslationQueryParameters, IPageTranslationQueryResult>(
    pageTranslationQuery,
);
